import React, { Component } from 'react'
import connect from "react-redux/es/connect/connect";

import { List, Datagrid, FilterForm } from 'components/list'
import { TextField, BooleanField } from 'components/field'
import { ActionButton, EditButton } from 'components/button'

import * as urls from './urls'
import * as utils from './utils';
import { DateInput, SelectInput, TextInput } from "components/input";

import { crudExportToEmail as crudExportToEmailAction } from 'actions/dataActions';

async function handleExport (props) {
  const { record } = props;
  return props.crudExportToEmail({ popup_notification_id: record.id }, urls.popupNotificationExportBackendPath)
}

const PopupNotificationFilter = (props) => (
  <FilterForm name='popup_notification_filter' {...props} initialValues={ props.defaultSearchValue }>
    <DateInput source='create_from' label='Create From'/>
    <DateInput source='create_to' label='Create To'/>
    <SelectInput source='notification_type' label='Notification Type' choices={utils.POPUP_NOTIFICATION_TYPE_CHOICES}/>
    <TextInput source="description" label="Description"/>
    <SelectInput source='send_status' label='Notification Status' choices={utils.POPUP_NOTIFICATION_STATUS_DISPLAY_CHOICES}/>
  </FilterForm>
);

const PopupNotificationExportButton = (props) => {
    return (
      <ActionButton
        {...props}
        label="EXPORT"
        action={() => { return handleExport(props); }}
      />
    );
};

class PopupNotificationList extends Component {
  render() {
    let {initialValues} = this.props;
    let autoLoadData = false;
    if (initialValues) {
      autoLoadData = true;
    } else {
      initialValues = {};
    }

    return (
      <List 
        hasCreate={true}
        filterValues={initialValues}
        filters={<PopupNotificationFilter defaultSearchValue={initialValues}/>}
        {...this.props}
        autoLoadData={autoLoadData}
      >
        <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
          <TextField source="id" label="ID"/>
          <TextField source="notification_type" label="TYPE" choices={utils.POPUP_NOTIFICATION_TYPE_CHOICES}/>
          <TextField source="description" label="DESCRIPTION"/>
          <TextField source="en_title" label="TITLE"/>
          <TextField source="add_time" label="CREATE TIME"/>
          <TextField source="effective_time" label="EFFECTIVE TIME"/>
          <TextField source="send_status" label="NOTIFICATION STATUS" choices={utils.POPUP_NOTIFICATION_STATUS_DISPLAY_CHOICES}/>
          <TextField source="accepted_shop_num" label="ACCEPTED"/>
          <TextField source="last_updated_by" label="LAST UPDATED BY"/>
          <BooleanField source="valid" label="STATUS"/>
          <EditButton linkTo={urls.popupNotificationEditFrontendPath} label="EDIT"/>
          <PopupNotificationExportButton 
            label="EXPORT"
            crudExportToEmail={this.props.crudExportToEmail}
          />
        </Datagrid>
      </List>
    )
  }
}

export default connect(
  state => ({
    initialValues: state.admin.filter[utils.PopupNotificationResourceName],
  }),
  {
    crudExportToEmail: crudExportToEmailAction
  }
)(PopupNotificationList);



// WEBPACK FOOTER //
// ./src/routes/notification/PopupNotificationList.js